


























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const auth = namespace("auth");

@Component
export default class AuthCallback extends Vue {
  @auth.Getter("getCodeVerifier")
  codeVerifier!: string | null;

  @auth.Getter("isLoading")
  isLoading!: boolean;

  @auth.Getter("getLoginError")
  loginError!: string | null;

  @auth.Action("fetchToken")
  fetchToken!: (params: any) => Promise<void>;

  mounted() {
    const authCode = this.$route.query.code;
    const verifier = this.codeVerifier;
    if (authCode && verifier) {
      this.fetchToken({ authCode, verifier }).then(() => {
        this.$router.push("/");
      });
    }
  }
}
